import { createStore, combineReducers, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import authReducer from '../reducers/authReducer';
import UserConfig from '../reducers/configReduser';
import UserprofileReducer from '../reducers/UserprofileReducer';
import breadCrumbReducer from '../reducers/breadCrumbReducer';
import TransactionGridReducer from '../reducers/transactionGridReducer';
import dashboardReducer from '../reducers/dashboardReducer';
import DashboardMerchantReducer from '../../src/components/dashboard.component/merchant/reducer';
import PayMentReducer from '../reducers/paymentlinkReducer';
import trasferReducer from '../reducers/transferReducer';
const persistConfig = {
    key: "root",
    storage,
    whitelist: ["auth"]
}
const rootReducer = combineReducers({
    oidc: authReducer,
    userConfig: UserConfig,
    userProfile: UserprofileReducer,
    breadCrumb:breadCrumbReducer,
    transactionGrid:TransactionGridReducer,
    dashboardReducer : dashboardReducer,
    merchantData : DashboardMerchantReducer,
    PayMentReducer : PayMentReducer,
    trasferReducer : trasferReducer,
});
const reducer = persistReducer(persistConfig, rootReducer)
let store = createStore(
    reducer,
    composeWithDevTools(applyMiddleware(thunk)),
);
const persistor = persistStore(store);

export { store, persistor }